export enum ShelfUiTypeEnum {
  slider = 'slider',
  twoRowSlider = 'twoRowSlider',
  grid = 'grid',
  oneitem = 'one_item',
  oneItem01 = 'oneItem01',
  slider01 = 'slider01',
  grid01 = 'grid01',
  grid02 = 'grid02',
  ranking01 = 'ranking01',
}
